import styled from 'styled-components';

import { COLOR, textStyles } from '#@/shared/utils/styles';

import { ActionCardContainer as DefaultActionCardContainer } from '../ActionCard';
import Icon from '../Icon';

const GAP = 20;
const OUTER_PADDING = 30;

export const CallToActionRegular = styled.div`
  ${textStyles.titleSmall500};
  color: ${COLOR.textPrimary};
`;

export const CallToActionLarge = styled.div`
  ${textStyles.titleMedium700};
  color: ${COLOR.textPrimary};
`;

interface ExplanationProps {
  $color: COLOR;
}

export const Explanation = styled.div<ExplanationProps>`
  ${textStyles.bodyMedium450};
  color: ${(props) => props.$color};
`;

export const Illustration = styled.div`
  svg {
    max-width: 240px;
    max-height: 165px;
    width: 100%;
  }

  padding: calc(50px - ${GAP}px) 0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const SidebarIllustration = styled.div`
  grid-area: sidebar;
  padding: ${OUTER_PADDING}px 0;

  svg {
    height: 220px;
  }
`;

export const ActionCardContainer = styled(DefaultActionCardContainer).attrs({ center: true })`
  margin-top: 30px;
`;

export const Bulletpoint = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 7px;

  ${textStyles.bodyMedium450};
  color: ${COLOR.textSecondary};
`;

export const BulletpointIcon = styled(Icon)`
  margin-top: 2px;
`;

interface MainProps {
  $alignContent: 'left' | 'center';
}

export const Main = styled.div<MainProps>`
  grid-area: main;
  padding: ${OUTER_PADDING}px;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    ({
      left: 'flex-start',
      center: 'center',
    })[props.$alignContent]};
  gap: ${GAP}px;
  text-align: ${(props) =>
    ({
      left: 'left',
      center: 'center',
    })[props.$alignContent]};
`;

export const TwoColumnsLayout = styled.div`
  display: grid;
  grid-template-areas: 'main sidebar';
  grid-template-columns: ${450 + OUTER_PADDING * 2}px auto;
  gap: calc(50px - ${GAP}px);
  justify-content: center;
  padding: 50px 0;
`;
